import { Row, Col, Card } from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'

const Cargando = () => {
    return <div>
        <Row>
        <Col md={2}><Skeleton height={80} /></Col>
        <Col md={2}><Skeleton height={80} /></Col>
        <Col md={2}><Skeleton height={80} /></Col>
        <Col md={2}><Skeleton height={80} /></Col>
        <Col md={2}><Skeleton height={80} /></Col>
        <Col md={2}><Skeleton height={80} /></Col>
    </Row>
    </div>
}

export default Cargando